<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Schedule</el-breadcrumb-item>
    <el-breadcrumb-item>MOQ Leadtime</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col>
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :inline="true" :model="formInline"  style="white-space: normal;  ">
      <el-form-item label="Brand:" >
        <el-select v-model="formInline.brands" multiple collapse-tags
              style="margin-left: 0px;"  filterable
              placeholder="please choose">
            <el-option
            v-for="item in this.brandList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Product:" >
        <el-input v-model="formInline.product" style="margin-left: 0px;" placeholder="Product" clearable ></el-input>
      </el-form-item>
   <el-form-item label="Description:" >
     <el-input v-model="formInline.description" style="margin-left: 0px;" placeholder="Description" clearable></el-input>
   </el-form-item>
   <!--<br>
   <div style="text-align:center">-->
      <el-form-item>
        <el-button type="primary"  @click="onSubmit">Search</el-button>
      </el-form-item>
      <el-form-item style="margin-left: 0px;">
        <el-button style="margin-left: 0px;" type="primary" @click="exportToExcel">Excel</el-button>
      </el-form-item>
      <!--</div>-->
    </el-form>

      <!-- Schedule 列表区域 -->
      <el-table :data="moqList" border stripe style="width: 100%">
        <el-table-column type="index" label="#"></el-table-column>
            <el-table-column
              prop="brand"
              label="Brand"         sortable
              width="100">
            </el-table-column>
            <el-table-column
              prop="product"      sortable
              label="Product" :show-overflow-tooltip="true"
              width="150">
            </el-table-column>

            <el-table-column
              prop="descr"
              label="Description" :show-overflow-tooltip="true"
              width="390">
            </el-table-column>

            <el-table-column
              prop="leadTime"
              label="Leadtime"        sortable
              width="150">
            </el-table-column>

            <el-table-column
              prop="minQty"        sortable
              label="Minimum quantity" :show-overflow-tooltip="true"
              width="160">
            </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        brands: [],
        product: '',
        description: '',
        token: '',
        page: 1,
        rows: 100
      },
      userName: '',
      moqList: [],
      brandList: [],
      total: 0,
      updateTime: '',
      brandParam: {
        userName: '',
        userType: ''
      }

    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getMoqs()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getMoqs()
    },
    exportToExcel () {
      /* 表示在当前页面打开新地址 */
      window.open('https://www.myirequest.com:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product + '&description=' + this.formInline.description, '_parent')
    },
    async getMoqs () {
      var brandsStr = ''

      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/show/moqList', { params: this.formInline })
      this.moqList = res.rows
      this.total = res.total
      if (res.rows && this.moqList[0]) {
        this.updateTime = this.moqList[0].createTime
      }

      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getMoqs()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getMoqs()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    }

  }
}
</script>

<style>
</style>
